module.exports = __webpack_public_path__ + "fonts/HeadlinerNo.03a61498.ttf";